<template>
<b-container>

<p class="h4 mb-4">{{pagePrompt}}</p>

    <b-row class="question">
      <b-col>
        <BaseRadioInput v-model="anyTravels"
                            :v="$v.anyTravels"
                            :label="$t('labels.anyTravels')"
                            :options=yesNoUnknownOptions
                            slug="anyTravels"/>
      </b-col>
    </b-row>

    <b-row v-if="anyTravels === 'Y'" class="question">
      <b-col cols="12" class="question">
        <BaseDateInput v-model="travelStart"
                            :v="$v.travelStart"
                            :label="$t('labels.travelStart')"
                            :messages="travelStartMessages"
                            slug="travelStart"/>
      </b-col>
      <b-col cols="12" class="question">
        <BaseDateInput v-model="travelEnd"
                            :v="$v.travelEnd"
                            :label="$t('labels.travelEnd')"
                            :messages="travelEndMessages"
                            slug="travelEnd"/>
      </b-col>
      <b-col cols="12">
        <BaseRadioInput v-model="travelOutsideMn"
                            :v="$v.travelOutsideMn"
                            :label="$t('labels.travelOutsideMn')"
                            :options=yesNoUnknownOptions
                            slug="travelOutsideMn"/>
      </b-col>
      <b-col cols="12" v-if="travelOutsideMn === 'Y'">
        <BaseSelector v-model="travelDestinationState"
                            :v="$v.travelDestinationState"
                            :label="$t('labels.travelDestinationState')"
                            :options=stateOptions
                            slug="travelDestinationState"/>
      </b-col>
      <b-col cols="12">
        <BaseRadioInput v-model="travelOutsideUsa"
                            :v="$v.travelOutsideUsa"
                            :label="$t('labels.travelOutsideUsa')"
                            :options=yesNoUnknownOptions
                            slug="travelOutsideUsa"/>
      </b-col>
      <b-col cols="12" class="question" v-if="false">
        <BaseRadioInput v-model="travelCruise"
                            :v="$v.travelCruise"
                            :label="$t('labels.travelCruise')"
                            :options=yesNoUnknownOptions
                            slug="travelCruise"/>
      </b-col>
      <b-col cols="12" class="question" v-if="travelOutsideUsa ==='Y'">
        <BaseCountrySelector v-model="travelDestinationObj"
          :v="$v.travelDestinationObj"
          :label="$t('labels.travelDestination')"
          slug="travelDestination"/>
      </b-col>
    </b-row>

    <b-row class="question" v-if="false">
      <b-col>
      <BaseRadioInput v-model="travelAir"
                            :v="$v.travelAir"
                            :label="$t('labels.travelAir')"
                            :options=yesNoUnknownOptions
                            slug="underlyingConditions"/>

      </b-col>
    </b-row>

    <b-row v-show="false" class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="healthCareExposure"
                            :v="$v.healthCareExposure"
                            :label="$t('labels.healthCareExposure')"
                            :options=yesNoUnknownOptions
                            slug="healthCareExposure"/>
      </b-col>
    </b-row>

    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="congregatePrior"
                            :v="$v.congregatePrior"
                            :label="$t('labels.congregatePrior')"
                            :options=yesNoUnknownOptions
                            slug="congregatePrior"/>
      </b-col>
    </b-row>

    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="detoxPrior"
                            :v="$v.detoxPrior"
                            :label="$t('labels.detoxPrior')"
                            :options=yesNoUnknownOptions
                            slug="detoxPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="correctionsPrior"
                            :v="$v.correctionsPrior"
                            :label="$t('labels.correctionsPrior')"
                            :options=yesNoUnknownOptions
                            slug="correctionsPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="shelterPrior"
                            :v="$v.shelterPrior"
                            :label="$t('labels.shelterPrior')"
                            :options=yesNoUnknownOptions
                            slug="correctshelterPriorionsPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="encampPrior"
                            :v="$v.encampPrior"
                            :label="$t('labels.encampPrior')"
                            :options=yesNoUnknownOptions
                            slug="encampPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="hcPrior"
                            :v="$v.hcPrior"
                            :label="$t('labels.hcPrior')"
                            :options=yesNoUnknownOptions
                            slug="hcPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="workplacePrior"
                            :v="$v.workplacePrior"
                            :label="$t('labels.workplacePrior')"
                            :options=yesNoUnknownOptions
                            slug="workplacePrior"/>
      </b-col>
    </b-row>

    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="restaurantPrior"
                            :v="$v.restaurantPrior"
                            :label="$t('labels.restaurantPrior')"
                            :options=yesNoUnknownOptions
                            slug="restaurantPrior"/>
      </b-col>
    </b-row>


    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="salonPrior"
                            :v="$v.salonPrior"
                            :label="$t('labels.salonPrior')"
                            :options=yesNoUnknownOptions
                            slug="salonPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="youthcampPrior"
                            :v="$v.youthcampPrior"
                            :label="$t('labels.youthcampPrior')"
                            :options=yesNoUnknownOptions
                            slug="youthcampPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="schoolPrior"
                            :v="$v.schoolPrior"
                            :label="$t('labels.schoolPrior')"
                            :options=yesNoUnknownOptions
                            slug="schoolPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="universityPrior"
                            :v="$v.universityPrior"
                            :label="$t('labels.universityPrior')"
                            :options=yesNoUnknownOptions
                            slug="universityPrior"/>
      </b-col>
    </b-row>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseRadioInput v-model="childcarePrior"
                            :v="$v.childcarePrior"
                            :label="$t('labels.childcarePrior')"
                            :options=yesNoUnknownOptions
                            slug="childcarePrior"/>
      </b-col>
    </b-row>

  <p class="h4 mb-4" v-if="false">{{pagePrompt}}</p>
    <b-row class="question" v-if="false">
      <b-col>
        <BaseMultiCheckboxInput v-model="selection"
                      :v="$v.eventPriorTypes"
                      :label="$t('labels.eventPrior')"
                      :options="eventOptions"
                      slug="eventPriorTypes"/>
      </b-col>
    </b-row>


    <b-row v-if="_.includes(selection, '9')" v-show="false">
      <b-col>
        <BaseTextInput v-model="otherEvent" v-if="_.includes(selection, '9')"
            :v="$v.otherEvent"
            :label="$t('labels.otherEvent')"
            slug="otherEvent"/>
      </b-col>
    </b-row>

  <b-row class="question" v-if="selection && selection.includes('10')" v-show="false">
    <b-col col="12" lg="10">
      <BaseRestaurantSelector v-model="restaurantPriorEntry"
                              :v="$v.restaurantPriorListString"
                              :label="$t('labels.restaurantPriorEntry')"
                              slug="restaurantPriorEntry"
                              :tip="$t('tips.otherSelection')"/>
      <small class="form-text text-muted">Start typing the restaurant or bar name in the box above.  Click 'Add' to add that establishment to your list of visited restaurant and bars below.</small>
    </b-col>
    <b-col col="12" lg="2">
      <b-button variant="primary" class="mt-4" @click="add">Add</b-button>
    </b-col>
</b-row>
  <b-row class="question" v-if="restaurantPriorEntry.value === 'R-1'" v-show="false">
    <b-col col="12" lg="10">
             <BaseTextInput v-model="restaurantOther"
                            :v="$v.restaurantOther"
                            :label="$t('labels.pleaseSpecify')"
                            slug="restaurantOther"/>
    </b-col>
</b-row>
<b-row  v-if="selection && selection.includes('10')" class="mb-5" v-show="false">
    <b-col cols="12">
      <b-list-group v-bind:flush="true">
        <b-list-group-item class="d-flex justify-content-between align-items-center"
                           v-for="(restaurant, idx) in restaurantPriorList" v-bind:key="idx">
          {{restaurant.text}}
          <b-button variant="danger" size="sm" @click="remove(idx)">X</b-button>
        </b-list-group-item>
      </b-list-group>
    </b-col>
  </b-row>

  <p class="h4 mb-4">{{pagePrompt}}</p>
    <b-row class="question">
      <b-col>
        <BaseRadioInput v-model="contactLabconf"
                            :v="$v.contactLabconf"
                            :label="$t('labels.contactLabconf')"
                            :options=yesNoUnknownOptions
                            slug="contactLabconf"/>
      </b-col>
    </b-row>

    <b-row class="question" v-show="false" v-if="contactLabconf === 'Y'">
      <b-col>
        <BaseRadioInput v-model="exposureCovidUs"
                            :v="$v.exposureCovidUs"
                            :label="$t('labels.exposureCovidUs')"
                            :options=yesNoUnknownOptions
                            slug="exposureCovidUs"/>
      </b-col>
    </b-row>

    <b-row class="question" v-show="false" v-if="contactLabconf === 'Y'">
      <b-col>
        <BaseRadioInput v-model="contactLabconfHh"
                            :v="$v.contactLabconfHh"
                            :label="$t('labels.contactLabconfHh')"
                            :options=yesNoUnknownOptions
                            slug="contactLabconfHh"/>
      </b-col>
    </b-row>

    <b-row class="question" v-if="contactLabconf === 'Y' && false">
      <b-col>
        <BaseRadioInput v-model="contactLabconfHc"
                            :v="$v.contactLabconfHc"
                            :label="$t('labels.contactLabconfHc')"
                            :options=yesNoUnknownOptions
                            slug="contactLabconfHc"/>
      </b-col>
    </b-row>

  <b-row class="question" v-if="contactLabconf === 'Y'">
      <b-col>
        <BaseTextInput v-model="contactOther"
                            :v="$v.contactOther"
                            :label="$t('labels.contactOther')"
                            slug="contactOther"/>
      </b-col>
    </b-row>
</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'
import minDate from '@/validators/minDate'
import maxDate from '@/validators/maxDate'
import BaseMultiCheckboxInput from "@/components/BaseMultiCheckboxInput";
import BaseTextInput from "@/components/BaseTextInput";
import _ from "lodash"
import axios from "axios"

export default {
  components: {BaseTextInput, BaseMultiCheckboxInput},
  mixins: [
       commonOptions
    ],
  data: () => ({
    selection: [],
    anyTravels: '',
    travelOutsideMn: '',
    travelDestinationState: '',
    travelOutsideUsa: '',
    travelCruise: '',
    travelDestination: '',
    travelDestinationObj: {},
    travelStart: null,
    travelEnd: null,
    travelAir: '',
    healthCareExposure: '',

    congregatePrior: '',
    detoxPrior: '',
    correctionsPrior: '',
    shelterPrior: '',
    encampPrior: '',
    hcPrior: '',
    workplacePrior: '',
    restaurantPrior: '',
    restaurantPriorEntry:"",
    restaurantPriorList: [],
    restaurantPriorListString: '',
    salonPrior: '',
    otherEvent: '',
    youthcampPrior: '',
    schoolPrior: '',
    universityPrior: '',
    childcarePrior: '',
    eventPrior: '',
    eventPriorTypes: '',
    contactLabconf: '',
    exposureCovidUs: '',
    contactLabconfHh: '',
    contactLabconfHc: '',
    contactOther: '',

    travelStartMessages: {
      maxDate: 'Travel Start Date must not be in the future.'
    },
    travelEndMessages: {
      minDate: 'Travel End Date must be after the Travel Start Date.',
      maxDate: 'Travel End Date must not be in the future.'
    },

    restaurants: [],
    restaurant: {
        code: '',
        name: '',
        otherName: '',
    },
    restaurantOther: '',

    options: []
  }),
  props: {
    symptoms: [Object],
  },
  validations() {
    return {
      anyTravels: { required: false },
      travelOutsideMn: { required: false, maxLength: maxLength(2) },
      travelDestinationState: { required: false, maxLength: maxLength(2) },
      travelOutsideUsa: { required: false },
      travelCruise: { required: false },
      travelAir: { required: false },
      travelDestination: { required: false },
      travelDestinationObj: {},
      travelStart: { required: false,
        maxDate: maxDate(new Date()),
      },
      travelEnd: { required: false,
        minDate: minDate(this.travelStart),
        maxDate: maxDate(new Date()),
      },
      healthCareExposure: { required: false },
      congregatePrior: { required: false },
      detoxPrior: { required: false },
      correctionsPrior: { required: false },
      shelterPrior: { required: false },
      encampPrior: { required: false },
      hcPrior: { required: false },
      workplacePrior: { required: false },
      restaurantPrior: { required: false },
      restaurantPriorListString: { required: false },
      salonPrior:  { required: false },
      youthcampPrior: { required: false },
      schoolPrior: { required: false },
      universityPrior: { required: false },
      childcarePrior:  { required: false },
      eventPrior:  { required: false },
      eventPriorTypes: { required: false },
      contactLabconf: { required: false },
      exposureCovidUs: { required: false },
      contactLabconfHh: { required: false },
      contactLabconfHc: { required: false },
      contactOther: { required: false },
      otherEvent: { required: false, maxLength: maxLength(50) },
      restaurantOther: { required: false, maxLength: maxLength(100)},
      restaurants: { required: false },

      form: [ 'anyTravels', 'travelOutsideMn', 'travelDestinationState', 'travelOutsideUsa', 'travelCruise', 'travelAir',
        'travelDestination', 'travelStart', 'travelEnd', 'healthCareExposure',
         'workplacePrior', 'restaurantPrior', 'salonPrior', 'youthcampPrior', 'schoolPrior',
         'universityPrior', 'childcarePrior', 'eventPrior', 'eventPriorTypes', 'contactLabconf',
         'exposureCovidUs', 'contactLabconfHh', 'contactLabconfHc', 'contactOther',
         'congregatePrior', 'detoxPrior', 'correctionsPrior', 'shelterPrior', 'encampPrior', 'hcPrior',
         'otherEvent',
         'restaurantOther', 'restaurants'
         ]
    }
  },
  watch: {
    selection() {
      this.eventPriorTypes = this.selection.join()
    },
    restaurantPriorList(){
      this.restaurantPriorListString = this.restaurantPriorList.map(e => e.value).join()
    },
    travelDestinationObj: function() {
      if (this.travelDestinationObj && this.travelDestinationObj.value) {
        this.travelDestination =  this.travelDestinationObj.value
      } else {
        this.travelDestination = ''
      }
    },
  },
  computed: {
      _: function() {
      return _
  },
  
    pagePrompt() {
      if (this.symptoms.covidSymptoms === 'Y') {
        var startDate = moment(this.symptoms.covidSymptomsStart).format('MM/DD/YYYY')
      }
      else {
        startDate = moment(this.symptoms.covidLastTested).format('MM/DD/YYYY')
      }
      return this.$i18n.t('exposurePage.pagePrompt', this.$root.$i18n.locale, {date: startDate})
    }
  },
  methods: {
    focusFirstStatus() {
      var errorElements = document.querySelectorAll(".is-invalid");
      if (errorElements && errorElements.length > 0) {
        var elmnt = document.getElementById(errorElements[0].id);
        elmnt.scrollIntoView();
      }
    },

    add() {
      if(/\S/.test(this.restaurantPriorEntry)){
        this.restaurantPriorList.push(this.restaurantPriorEntry)

        this.restaurant = {
            code: this.restaurantPriorEntry.value,
            name: this.restaurantPriorEntry.text,
            otherName: this.restaurantOther,
        },
        this.restaurants.push(this.restaurant)

      }
      this.restaurantPriorEntry = ''
      this.restaurantOther = ''
      this.restaurant = {
          code: '',
          name: '',
          otherName: '',
      }
    },

    remove(idx){
      this.restaurantPriorList.splice(idx,1)
      this.restaurants.splice(idx,1)
    },

    validate() {
      this.$v.form.$touch();
      this.$nextTick(() => this.focusFirstStatus())
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
  }
}
</script>

<style>
  legend {
    font-weight: 750;
  }
  .question {
    margin-bottom: 20px;
  }
</style>
